var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 53,
    viewBox: "0 0 121 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8916 46.9249H95.7096C96.6426 44.6178 98.2179 42.6067 100.346 41.0649C102.609 39.4281 105.206 38.5455 107.871 38.4729C109.553 34.5122 110.876 30.1325 111.642 26.0377C110.882 21.943 109.553 17.5633 107.871 13.6026C105.206 13.5244 102.609 12.6474 100.346 11.0106C98.2179 9.4688 96.6426 7.45769 95.7096 5.15057H23.8916C22.9587 7.45769 21.3834 9.4688 19.255 11.0106C16.9926 12.6474 14.3949 13.53 11.7303 13.6026C10.0488 17.5633 8.72484 21.943 7.95952 26.0377C8.71926 30.1325 10.0488 34.5122 11.7303 38.4729C14.3949 38.5511 16.9926 39.4281 19.255 41.0649C21.3834 42.6067 22.9587 44.6178 23.8916 46.9249ZM19.7299 0H99.8659C99.8659 2.79311 101.095 5.20086 103.357 6.83763C105.62 8.4744 108.29 8.89338 110.943 8.02193C113.731 13.5076 115.893 20.2895 116.859 26.0322C115.893 31.7748 113.731 38.5567 110.943 44.0424C108.29 43.1709 105.62 43.5843 103.357 45.2267C101.095 46.8634 99.8659 49.2712 99.8659 52.0643H19.7299C19.7299 49.2712 18.5009 46.8634 16.2384 45.2267C13.976 43.5899 11.3057 43.1709 8.65222 44.0424C5.86466 38.5567 3.70276 31.7748 2.73633 26.0322C3.70276 20.2895 5.86466 13.5076 8.65222 8.02193C11.3057 8.89338 13.976 8.47998 16.2384 6.83763C18.5009 5.20086 19.7299 2.79311 19.7299 0Z",
    fill: "url(#paint0_linear_87_219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1668 8.92132C20.3789 7.31805 21.8481 5.11147 22.4347 2.5697L20.1499 0C20.1499 2.79315 18.9209 5.20085 16.6585 6.83763C14.396 8.47442 11.7258 8.89339 9.07227 8.02193L10.5024 10.9603C13.2005 11.2787 15.8708 10.5805 18.1668 8.92132Z",
    fill: "url(#paint1_linear_87_219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4362 2.57031C21.8497 5.11208 20.3805 7.31867 18.1683 8.92194C15.8779 10.5811 13.2077 11.2794 10.5039 10.9609L12.1463 13.5977C14.8109 13.5195 17.4086 12.6424 19.671 11.0056C21.7994 9.46381 23.3747 7.45274 24.3077 5.1456L22.4307 2.5759L22.4362 2.57031Z",
    fill: "url(#paint2_linear_87_219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76505 26.0337C6.64769 21.0507 8.34034 15.6487 10.5022 10.9618L9.07214 8.02344C6.28458 13.5092 4.12268 20.291 3.15625 26.0337H5.76505Z",
    fill: "url(#paint3_linear_87_219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5028 10.9609C8.33532 15.6534 6.64267 21.0498 5.76562 26.0328H8.38001C9.13975 21.938 10.4693 17.5584 12.1508 13.5977L10.5084 10.9609H10.5028Z",
    fill: "url(#paint4_linear_87_219)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5022 41.1031C8.33475 36.4106 6.6421 31.0142 5.76505 26.0312H3.15625C4.12268 31.774 6.28458 38.5557 9.07214 44.0415L10.5022 41.1031Z",
    fill: "url(#paint5_linear_87_219)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76535 26.0312C6.64799 31.0142 8.34064 36.4162 10.5025 41.1031L12.1449 38.4664C10.4634 34.5057 9.13948 30.126 8.37415 26.0312H5.75977H5.76535Z",
    fill: "url(#paint6_linear_87_219)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.673 41.0647C17.4105 39.4279 14.8129 38.5453 12.1482 38.4727L10.5059 41.1094C13.204 40.791 15.8743 41.4893 18.1703 43.1484C20.3824 44.7517 21.8516 46.9582 22.4382 49.5L24.3152 46.9303C23.3823 44.6232 21.8069 42.6121 19.6786 41.0703L19.673 41.0647Z",
    fill: "url(#paint7_linear_87_219)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1668 43.1492C15.8764 41.49 13.2061 40.7917 10.5024 41.1102L9.07227 44.0486C11.7258 43.1771 14.396 43.5905 16.6585 45.2329C18.9209 46.8696 20.1499 49.2773 20.1499 52.0705L22.4347 49.5008C21.8481 46.959 20.3789 44.7524 18.1668 43.1492Z",
    fill: "url(#paint8_linear_87_219)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.952 8.92132C99.7394 7.31805 98.2702 5.11147 97.6836 2.5697L99.9684 0C99.9684 2.79315 101.197 5.20085 103.46 6.83763C105.722 8.47442 108.393 8.89339 111.046 8.02193L109.616 10.9603C106.918 11.2787 104.248 10.5805 101.952 8.92132Z",
    fill: "url(#paint9_linear_87_219)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6898 2.57031C98.2763 5.11208 99.7455 7.31867 101.958 8.92194C104.248 10.5811 106.918 11.2794 109.622 10.9609L107.98 13.5977C105.315 13.5195 102.717 12.6424 100.455 11.0056C98.3266 9.46381 96.7513 7.45274 95.8184 5.1456L97.6953 2.5759L97.6898 2.57031Z",
    fill: "url(#paint10_linear_87_219)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.353 26.0337C113.471 21.0507 111.778 15.6487 109.616 10.9618L111.046 8.02344C113.834 13.5092 115.996 20.291 116.962 26.0337H114.353Z",
    fill: "url(#paint11_linear_87_219)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.617 10.9609C111.784 15.6534 113.477 21.0498 114.354 26.0328H111.74C110.98 21.938 109.65 17.5584 107.969 13.5977L109.611 10.9609H109.617Z",
    fill: "url(#paint12_linear_87_219)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.616 41.1031C111.784 36.4106 113.476 31.0142 114.353 26.0312H116.962C115.996 31.774 113.834 38.5557 111.046 44.0415L109.616 41.1031Z",
    fill: "url(#paint13_linear_87_219)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.353 26.0312C113.471 31.0142 111.778 36.4162 109.616 41.1031L107.974 38.4664C109.655 34.5057 110.979 30.126 111.744 26.0312H114.359H114.353Z",
    fill: "url(#paint14_linear_87_219)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.443 41.0647C102.705 39.4279 105.303 38.5453 107.968 38.4727L109.61 41.1094C106.912 40.791 104.242 41.4893 101.946 43.1484C99.7335 44.7517 98.2643 46.9582 97.6778 49.5L95.8008 46.9303C96.7337 44.6232 98.309 42.6121 100.437 41.0703L100.443 41.0647Z",
    fill: "url(#paint15_linear_87_219)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.952 43.1492C104.242 41.49 106.912 40.7917 109.616 41.1102L111.046 44.0486C108.393 43.1771 105.722 43.5905 103.46 45.2329C101.197 46.8696 99.9684 49.2773 99.9684 52.0705L97.6836 49.5008C98.2702 46.959 99.7394 44.7524 101.952 43.1492Z",
    fill: "url(#paint16_linear_87_219)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.118 26.032L112.515 18.5352L102.963 25.9873L112.515 33.5288L120.118 26.032Z",
    fill: "#7BAEDE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.935 26.0295L112.298 29.6159L107.723 25.996L112.287 22.4375L115.935 26.0295Z",
    fill: "#5A78BB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.727 24.7527L113.336 21.4121L112.397 20.4904L112.515 18.5352L116.157 22.1327L120.118 26.032H118.028L116.727 24.7527Z",
    fill: "url(#paint17_linear_87_219)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.773 21.7585L105.343 25.9929L102.963 25.9873L110.342 20.2334L112.515 18.5352L112.398 20.4904L110.773 21.7585Z",
    fill: "url(#paint18_linear_87_219)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.337 30.6567L116.728 27.3105L118.029 26.0312H120.119L116.158 29.9361L112.527 33.5169L112.521 33.4945L112.415 31.5673L113.337 30.6567Z",
    fill: "url(#paint19_linear_87_219)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.343 25.99L110.778 30.2802L112.404 31.5707L112.415 31.5651L112.521 33.4924L112.527 33.5147L112.515 33.5259L110.348 31.8165L102.963 25.9844L105.343 25.99Z",
    fill: "url(#paint20_linear_87_219)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.297 29.6177L113.978 27.9641L115.934 26.0312H116.961H118.028L116.727 27.3105L113.336 30.6567L112.414 31.5673L112.297 29.6177Z",
    fill: "url(#paint21_linear_87_219)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.168 28.7239L112.297 29.6177L112.414 31.5673L112.403 31.5729L110.777 30.2825L105.342 25.9922L107.722 25.9978L111.168 28.7239Z",
    fill: "url(#paint22_linear_87_219)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.934 26.0299L113.979 24.1026L112.286 22.4379L112.398 20.4883L113.336 21.41L116.727 24.7506L118.029 26.0299H116.962H115.934Z",
    fill: "url(#paint23_linear_87_219)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.163 23.3094L107.722 25.9964L105.342 25.9908L110.772 21.7564L112.397 20.4883L112.286 22.4379L111.163 23.3094Z",
    fill: "url(#paint24_linear_87_219)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.365 26.0324L112.22 28.1496L109.505 26.0045L112.203 23.8984L114.365 26.0324Z",
    fill: "url(#paint25_linear_87_219)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.287 22.4375L112.203 23.8955L114.354 26.0295H115.935L112.287 22.4375Z",
    fill: "url(#paint26_linear_87_219)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.298 29.6199L112.22 28.1507L109.505 26.0056L107.723 26L112.298 29.6199Z",
    fill: "url(#paint27_linear_87_219)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.432 24.4988L109.505 26.0016L107.723 25.996L111.164 23.309L112.287 22.4375L112.203 23.8955L111.432 24.4988Z",
    fill: "url(#paint28_linear_87_219)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.22 28.1485L114.354 26.048L114.365 26.0312H115.935L113.979 27.9641L112.298 29.6177L112.22 28.1485Z",
    fill: "url(#paint29_linear_87_219)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.032L7.60854 18.5352L17.1555 25.9873L7.60854 33.5288L0 26.032Z",
    fill: "#7BAEDE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18359 26.0295L7.82028 29.6159L12.401 25.996L7.83145 22.4375L4.18359 26.0295Z",
    fill: "#5A78BB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39088 24.7527L6.78177 21.4121L7.72027 20.4904L7.60854 18.5352L3.96069 22.1327L0 26.032H2.09486L3.39088 24.7527Z",
    fill: "url(#paint30_linear_87_219)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3523 21.7585L14.7822 25.9929L17.1564 25.9873L9.78245 20.2334L7.60938 18.5352L7.7211 20.4904L9.3523 21.7585Z",
    fill: "url(#paint31_linear_87_219)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78177 30.6567L3.39088 27.3105L2.09486 26.0312H0L3.96069 29.9361L7.59737 33.5169V33.4945L7.70909 31.5673L6.78177 30.6567Z",
    fill: "url(#paint32_linear_87_219)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7816 25.99L9.34617 30.2802L7.71497 31.5707L7.70938 31.5651L7.59766 33.4924V33.5147L7.60883 33.5259L9.77631 31.8165L17.1558 25.9844L14.7816 25.99Z",
    fill: "url(#paint33_linear_87_219)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82166 29.6177L6.14577 27.9641L4.18498 26.0312H3.1571H2.0957L3.39172 27.3105L6.78261 30.6567L7.70994 31.5673L7.82166 29.6177Z",
    fill: "url(#paint34_linear_87_219)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94914 28.7239L7.82071 29.6177L7.70898 31.5673L7.71457 31.5729L9.34577 30.2825L14.7812 25.9922L12.4015 25.9978L8.94914 28.7239Z",
    fill: "url(#paint35_linear_87_219)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18498 26.0299L6.14577 24.1026L7.83283 22.4379L7.72111 20.4883L6.78261 21.41L3.39172 24.7506L2.0957 26.0299H3.1571H4.18498Z",
    fill: "url(#paint36_linear_87_219)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95332 23.3094L12.4001 25.9964L14.7798 25.9908L9.34995 21.7564L7.71875 20.4883L7.83048 22.4379L8.95332 23.3094Z",
    fill: "url(#paint37_linear_87_219)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75391 26.0324L7.90463 28.1496L10.614 26.0045L7.9158 23.8984L5.75391 26.0324Z",
    fill: "url(#paint38_linear_87_219)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83145 22.4375L7.91524 23.8955L5.76452 26.0295H4.18359L7.83145 22.4375Z",
    fill: "url(#paint39_linear_87_219)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82031 29.6199L7.90411 28.1507L10.6135 26.0056L12.4011 26L7.82031 29.6199Z",
    fill: "url(#paint40_linear_87_219)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68674 24.4988L10.614 26.0016L12.4016 25.996L8.95488 23.309L7.83203 22.4375L7.91583 23.8955L8.68674 24.4988Z",
    fill: "url(#paint41_linear_87_219)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90407 28.1485L5.7701 26.048L5.75334 26.0312H4.18359L6.14439 27.9641L7.82028 29.6177L7.90407 28.1485Z",
    fill: "url(#paint42_linear_87_219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_219",
    x1: 62.1583,
    y1: 52.0643,
    x2: 62.1583,
    y2: -0.00000310328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_219",
    x1: 9.07227,
    y1: 5.51926,
    x2: 22.4347,
    y2: 5.51926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91A8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCE4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_219",
    x1: 10.5039,
    y1: 8.08399,
    x2: 24.3132,
    y2: 8.08399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_219",
    x1: 6.83204,
    y1: 26.0337,
    x2: 6.83204,
    y2: 8.02344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_219",
    x1: 8.9554,
    y1: 26.0328,
    x2: 8.9554,
    y2: 10.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6176AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_87_219",
    x1: 6.83204,
    y1: 44.0415,
    x2: 6.83204,
    y2: 26.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_87_219",
    x1: 0.00029022,
    y1: 41.1031,
    x2: 0.55892,
    y2: 26.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6176AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_87_219",
    x1: 10.5003,
    y1: 43.9807,
    x2: 24.3096,
    y2: 43.9807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2C8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_87_219",
    x1: 9.07227,
    y1: 46.5512,
    x2: 22.4347,
    y2: 46.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_87_219",
    x1: 104.365,
    y1: 11.0329,
    x2: 104.365,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91A8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCE4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_87_219",
    x1: 95.8072,
    y1: 8.08399,
    x2: 109.617,
    y2: 8.08399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_87_219",
    x1: 113.286,
    y1: 26.0337,
    x2: 113.286,
    y2: 8.02344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_87_219",
    x1: 111.164,
    y1: 26.0328,
    x2: 111.164,
    y2: 10.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_87_219",
    x1: 113.286,
    y1: 44.0415,
    x2: 113.286,
    y2: 26.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_87_219",
    x1: -100.68,
    y1: 41.1031,
    x2: -100.122,
    y2: 26.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_87_219",
    x1: 95.8064,
    y1: 43.9807,
    x2: 109.616,
    y2: 43.9807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_87_219",
    x1: 97.6892,
    y1: 46.5512,
    x2: 111.046,
    y2: 46.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_87_219",
    x1: 112.397,
    y1: 22.2836,
    x2: 120.118,
    y2: 22.2836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_87_219",
    x1: 102.963,
    y1: 22.2668,
    x2: 112.515,
    y2: 22.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_87_219",
    x1: 112.415,
    y1: 29.7741,
    x2: 120.119,
    y2: 29.7741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_87_219",
    x1: 102.963,
    y1: 29.7551,
    x2: 112.527,
    y2: 29.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_87_219",
    x1: 112.297,
    y1: 28.8021,
    x2: 118.028,
    y2: 28.8021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_87_219",
    x1: 105.342,
    y1: 28.7798,
    x2: 112.414,
    y2: 28.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_87_219",
    x1: 112.286,
    y1: 23.2591,
    x2: 118.029,
    y2: 23.2591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57688E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_87_219",
    x1: 105.342,
    y1: 23.2423,
    x2: 112.397,
    y2: 23.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_87_219",
    x1: 111.935,
    y1: 28.1496,
    x2: 111.935,
    y2: 23.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C1F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_87_219",
    x1: 112.203,
    y1: 24.2307,
    x2: 115.935,
    y2: 24.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4897D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_87_219",
    x1: 107.723,
    y1: 27.81,
    x2: 112.298,
    y2: 27.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4897D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_87_219",
    x1: 110.946,
    y1: 25.158,
    x2: 109.75,
    y2: 23.9626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4889C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_87_219",
    x1: 114.13,
    y1: 27.8356,
    x2: 113.331,
    y2: 27.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#499FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_87_219",
    x1: 0,
    y1: 22.2836,
    x2: 7.72027,
    y2: 22.2836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_87_219",
    x1: 7.60938,
    y1: 22.2668,
    x2: 17.1564,
    y2: 22.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_87_219",
    x1: 0,
    y1: 29.7741,
    x2: 7.70909,
    y2: 29.7741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_87_219",
    x1: 7.59766,
    y1: 29.7551,
    x2: 17.1558,
    y2: 29.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_87_219",
    x1: 2.0957,
    y1: 28.8021,
    x2: 7.82166,
    y2: 28.8021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_87_219",
    x1: 7.70898,
    y1: 28.7798,
    x2: 14.7812,
    y2: 28.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_87_219",
    x1: 2.0957,
    y1: 23.2591,
    x2: 7.83283,
    y2: 23.2591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_87_219",
    x1: 7.71875,
    y1: 23.2423,
    x2: 14.7798,
    y2: 23.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57688E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_87_219",
    x1: 8.18395,
    y1: 0.00024539,
    x2: 8.18395,
    y2: 0.00024539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C1F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_87_219",
    x1: 6.79798,
    y1: 25.0184,
    x2: 5.99356,
    y2: 24.2195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4889C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_87_219",
    x1: 10.3509,
    y1: 28.0502,
    x2: 9.17778,
    y2: 26.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#499FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_87_219",
    x1: 7.83203,
    y1: 24.2195,
    x2: 12.4016,
    y2: 24.2195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4897D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_87_219",
    x1: 4.18359,
    y1: 27.8245,
    x2: 7.90407,
    y2: 27.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4897D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264C9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationContainer);
export default __webpack_public_path__ + "static/media/pagination-container.8d17966a78a910f6bf0e4ef85ea2f491.svg";
export { ForwardRef as ReactComponent };